import React, { createRef, useContext, useMemo } from 'react';
import { Dialog } from 'primereact/dialog';

import { UserDetailsContext } from 'context/userDetailsContext';
import { useFileManagerContext } from 'modules/FileManagerV2/context/FileManagerContext';
import { bytesToFormattedSize } from 'utils/utils';
import ResizableDataTable from 'components/ResizableDataTable/ResizableDataTable';
import CustomHeader from './CustomHeader';
import FileVersionTitleTemplate from './FileVersionTitleTemplate';
import UploadedTemplate from '../../view/list/templates/UploadedTemplate';
import FileVersionActionsTemplate from './FileVersionActionsTemplate';

function FileVersionsModal() {
  const userContext = useContext(UserDetailsContext);
  const { modals, selectedItem } = useFileManagerContext();
  const { showUploadedVersionsModal, setShowUploadedVersionsModal } = modals;

  const versions = selectedItem?.versions ?? [];
  const itemsRef = useMemo(
    () =>
      Array(versions.length)
        .fill(null)
        .map(() => createRef()),
    [versions.length]
  );

  const columns = useMemo(
    () => [
      {
        field: 'display_name',
        header: 'Title',
        body: (rowData) => <FileVersionTitleTemplate rowData={rowData} />,
        sortable: true,
      },
      {
        field: 'size',
        header: 'File Size',
        body: (rowData) => <span className="text-muted">{rowData?.size ? bytesToFormattedSize(rowData.size) : '-'}</span>,
        sortable: true,
      },
      {
        field: 'version_created',
        header: 'Date Uploaded',
        body: (rowData) => <UploadedTemplate userContext={userContext} rowData={rowData} />,
        sortable: true,
      },
      {
        field: 'action',
        header: 'Actions',
        body: (rowData, e) => <FileVersionActionsTemplate rowData={rowData} e={e} itemsRef={itemsRef} />,
        fixed: true,
        width: '100px',
      },
    ],
    [userContext, itemsRef]
  );

  return (
    <Dialog
      header={<CustomHeader title="File Versions" onHide={() => setShowUploadedVersionsModal(false)} />}
      visible={showUploadedVersionsModal}
      style={{ width: '50%' }}
      onHide={() => setShowUploadedVersionsModal(false)}
      className="rounded casefile-wrap"
      closable={false}
      draggable={false}
    >
      <ResizableDataTable value={versions} columns={columns} storageKey="file_versions_modal" sortField="version_uploaded" sortOrder={-1} />
    </Dialog>
  );
}

export default FileVersionsModal;
